<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="950px"
      top="25vh"
      :show-close="false"
      :close-on-click-modal="false"
      :center="true">
      <div class="content">
        <div class="platform-bg" :style="`background: url(${backgroundImg || 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/login-bg.png'}) left center/cover no-repeat`">
          <p class="platform-name">{{ title || '大数据服务平台' }}</p>
          <p class="platform-welcome">欢迎进入{{ title || '大数据服务平台' }}！</p>
        </div>
        <div class="content-form">
          <p class="content-tips">为了保障您的账号安全，请修改您的初始密码！</p>
          <el-form ref="resetForm" :model="resetForm" :rules="rules" class="reset-form">
            <el-form-item label="新密码" prop="password" class="password">
              <el-input v-model="resetForm.password" type="password" auto-complete="new-password"

                        minlength="8" maxlength="20" placeholder="输入8-20位密码，至少包含数字和字母"></el-input>
              <img v-if="passFlag" src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/pass.svg" alt="" class="password-pass">
            </el-form-item>

            <el-form-item label="确认密码" prop="checkPass" class="password">
              <el-input v-model="resetForm.checkPass" type="password" auto-complete="new-password"
                        minlength="8" maxlength="20" placeholder="请再次输入密码"></el-input>
              <img v-if="checkPassFlag" src="https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/background-img/pass.svg" alt="" class="password-pass">
            </el-form-item>
          </el-form>
          <el-button :style="{backgroundColor: (resetForm.password.length> 0 && resetForm.checkPass.length > 0? '#3269FF':'#c4c4c4')}" class="btn-submit" :loading="btnLoading" @click="handleSubmit">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changePasswordApi } from '../fetch'
import { logoutApi } from 'src/api/common'
export default {
  name: 'ChangePasswordDialog',
  components: {
  },
  props: {
    title: {
      type: String,
    },
    backgroundImg: {
      type: String,
    },
  },
  data () {
    const validatePass = (rule, value, callback) => {
      const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$/

      this.passFlag = false
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!reg.test(value)) {
        callback(new Error('密码必须由8-20位 至少包含数字和字母'))
      } else {
        if (this.resetForm.checkPass !== '') {
          // 对第二个密码框单独验证
          this.$refs.resetForm.validateField('checkPass')
        }
        this.passFlag = true
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      this.checkPassFlag = false
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        this.checkPassFlag = true
        callback()
      }
    }

    return {
      btnLoading: false,
      dialogVisible: true,
      checkPassFlag: false,
      passFlag: false,
      resetForm: {
        password: '',
        checkPass: '',

      },
      rules: {
        password: [
          { required: true, message: '密码不能为空', trigger: ['change', 'blur'] },
          { validator: validatePass, trigger: ['change', 'blur'] },
        ],
        checkPass: [
          { required: true, message: '请再次输入密码', trigger: ['change', 'blur'] },
          { validator: validatePassCheck, trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  computed: {
  },
  created () {},
  methods: {
    async handleSubmit () {
      try {
        await this.$refs.resetForm.validate()
        this.btnLoading = true
        await changePasswordApi({
          userPassword: this.resetForm.password,
        })
        await logoutApi()
        this.$emit('close')
        this.$router.push({ path: '/login' })
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang='scss' scoped>
  .content {
    display: flex;
    height: 400px;
    .platform-bg {
      height: 400px;
      width: 450px;
      border-radius: 8px 0 0 8px;
      padding-top: 60px;
      padding-left: 60px;
      color: #fff;
      .platform-name {
        margin-bottom: 20px;
        font-size: 36px;
        line-height: 36px;
        font-weight: bold;
      }
      .platform-welcome {
        font-size: 16px;
      }
    }
    &-form {
      padding: 56px 70px 56px;
    }
    &-title {
      margin-bottom: 20px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 192px;
        height:1px;
        background-color:#E8E8E8;
        left:-5px;
        top:50%;

      }
      &::before {
        content: '';
        position: absolute;
        width: 192px;
        height:1px;
        background-color:#E8E8E8;
        right:-5px;
        top:50%;
      }
    }
    &-tips {
      margin-bottom: 20px;
      color: #3269FF;
    }
    ::v-deep .el-input__inner {
      height: 46px;
      line-height: 46px;
      border-radius: 2px;
      border: 1px solid #E8E8E8 ;

    }
    .reset-form {
      margin: 0 auto;
      width: 360px;
      .password {
        position: relative;
        &-pass {
          position: absolute;
          right: -30px;
          top: 46px;
        }
      }
    }
    .btn-submit {
      margin-top: 22px;
      height: 46px;
      width: 360px;
      border: none;
      cursor: pointer;
      color: #fff;
      border-radius: 2px;
      font-size: 16px;
      background-color: #3269FF;
    }

  }
</style>
